import Vue from 'vue'

interface IUploadPayload {
  file?: File
  images?: Blob[]
}
interface IBodyInit {
  token: string
  encryptData: string
}

export async function uploadHandler(payload: IUploadPayload, bizToken: string) {
  // console.log('payload', payload)
  const body = new FormData()
  if (payload.images) {
    for (const [index, image] of payload.images.entries()) {
      const imageSuffix = image.type === 'image/webp' ? 'webp' : 'jpeg'
      body.append('image', image, `out${index + 1}.${imageSuffix}`)
    }
  }
  // TODO: 优化去掉
  if (payload.file) {
    body.append('file', payload.file)
  }
  body.append('token', bizToken)
  const { data } = await Vue.prototype.$http.post(
    '/liveness/h5/v1/detection',
    body,
    {
      headers: {'Content-Type': 'multipart/form-data'},
    })

  return data
}

export async function uploadHandlerV2(payload: IUploadPayload, bizToken: string) {
  // console.log('payload', payload)
  const body = new FormData()
  if (payload.images) {
    for (const [index, image] of payload.images.entries()) {
      const imageSuffix = image.type === 'image/webp' ? 'webp' : 'jpeg'
      body.append('image', image, `out${index + 1}.${imageSuffix}`)
    }
  }
  // TODO: 优化去掉
  if (payload.file) {
    body.append('file', payload.file)
  }
  body.append('token', bizToken)
  const { data } = await Vue.prototype.$http.post(
    '/liveness/h5/v2/detection',
    body,
    {
      headers: {'Content-Type': 'multipart/form-data'},
    })

  return data
}
export async function uploadHandlerV3(encryptDataAgm: string, bizToken: string) {
  const body: IBodyInit = {
    token: bizToken,
    encryptData: encryptDataAgm,
  }
  const { data } = await Vue.prototype.$http.post(
    '/liveness/h5/v3/detection',
    body,
    {
      headers: {'Content-Type': 'application/json'},
    })

  return data
}
